import { render, staticRenderFns } from "./ProfilUser.vue?vue&type=template&id=c2af6656&scoped=true&"
import script from "./ProfilUser.vue?vue&type=script&lang=js&"
export * from "./ProfilUser.vue?vue&type=script&lang=js&"
import style0 from "./ProfilUser.vue?vue&type=style&index=0&id=c2af6656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2af6656",
  null
  
)

export default component.exports